import { Modal } from '../../atoms/Modal';
import { Button } from '../../atoms/Button';
import { Group } from '../../atoms/Group';
import { Text } from '../../atoms/Text';
import type { CoreProps } from '../../types';
import { useShouldRender } from '../../../hooks/useShouldRender';

export interface ConfirmDialogProps extends CoreProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  loading?: boolean;
  danger?: boolean;
}

export function ConfirmDialog({
  opened,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  loading,
  danger,
  testId,
  view = 'all',
}: ConfirmDialogProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;

  return (
    <Modal opened={opened} onClose={onClose} title={title} testId={testId}>
      <Text mb="md">{message}</Text>
      <Group justify="flex-end">
        <Button variant="default" onClick={onClose}>
          {cancelLabel}
        </Button>
        <Button color={danger ? 'red' : undefined} loading={loading} onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </Group>
    </Modal>
  );
}
